/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-30 15:13:43
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-06 13:28:43
 * @FilePath: /unifyxp-v2-store-portal/src/components/NoDataPage/NoDataPage.tsx
 */
/**
 *  A page without data
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */
import { Button } from '@/src/components/Antd';
import DropDown from '@/src/components/Antd/DropDown/DropDown';
import React from 'react';
import { IMAGE_URL } from 'src/tools/constant';
import css from './NoDataPage.less';

const NoDataPage = (props) => {
  const {
    title,
    introduce,
    buttonTitle,
    onClick,
    renderButton,
    addButtonOverlay,
    disabled,
  } = props;
  return (
    <div className={css.nodataContain}>
      <div className={css.title}>{title}</div>
      <img className={css.image} src={`${IMAGE_URL}default/nodata.png`} />
      <div className={css.introduce}>{introduce}</div>
      {renderButton ? (
        renderButton()
      ) : (
        <>
          {buttonTitle && addButtonOverlay ? (
            <DropDown
              className={css.dropDown}
              overlay={addButtonOverlay}
              disabled={disabled}
              trigger={['click']}>
              <Button className={css.button} disabled={disabled}>
                {buttonTitle}
              </Button>
            </DropDown>
          ) : (
            <Button
              className={css.button}
              onClick={onClick}
              disabled={disabled}>
              {buttonTitle}
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export default NoDataPage;
